<template>
    <div>
        <ion-grid>
            <ion-row class="row-divider"></ion-row>
            <ion-row class="search-view">
                <ion-col >
                    <ion-row align-items-stretch>
                        <ion-col size="12" size-md="3">
                            <ion-label>Corpoate Name</ion-label>
                            <div class="border-line-34 margin-top-10">
                                <ion-input id="corporateName" v-model="corporateName" class="form-input" type="text"></ion-input>
                            </div>
                        </ion-col>
                        <ion-col size="12" size-md="3">
                            <ion-label>Status</ion-label>
                            <div class="border-line-34 margin-top-10">
                                <ion-select 
                                    :value="statuss"
                                    @ionChange="statuss = $event.target.value" 
                                    class="form-select select-mobile"
                                    placeholder="Select Status"
                                    interface="action-sheet">
                                    <ion-select-option
                                        v-for="item in statuses"
                                        :key="item.code"
                                        :value="item.code"
                                    >
                                        {{ item.description }}
                                    </ion-select-option>
                                </ion-select>
                                <select
                                    class="input-select select-web"
                                    v-model="statuss"
                                    placeholder="Select Status"
                                    >
                                    <option
                                    v-for="item in statuses"
                                        :key="item.code"
                                        :value="item.code"
                                    >{{ item.description }}</option>
                                </select>
                            </div>
                        </ion-col>
                        <ion-col size="12" size-md="3">
                            <br />
                            <ion-button class="btn-search margin-top-10" @click="searchCorporate">Search</ion-button>
                            <ion-button class="btn-clear margin-top-10" @click="clearFields">
                                <ion-icon :icon="refresh"></ion-icon>
                            </ion-button>
                        </ion-col>
                    </ion-row>
                </ion-col>
            </ion-row>
            <ion-row class="row-divider"></ion-row>
            <ion-row class="list-view">
                <ion-col>
                    <ion-row class="list-head">
                        <ion-col size="12" size-md="2">
                            <ion-label>Corpoate ID</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="3">
                            <ion-label>Corpoate Name</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="2">
                            <ion-label>Status</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="2">
                            <ion-label>Edit User</ion-label>
                        </ion-col>
                    </ion-row>
                    <hr />
                    <ion-row class="list-item" v-for="(item, index) in corporateList" :key="item">
                        <ion-col size="12" size-md="2">
                        <ion-label>{{ item.corporateId }}</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="3" style="cursor: pointer;" @click="addCorporateNameInFilter(item.corporateName)">
                        <ion-label>{{ item.corporateName }}</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="2">
                        <ion-label 
                        v-bind:class="[{'active': item.status.code == 'A'}, {'in-active': item.status.code == 'I'}]">{{ convertUppercase(item.status.description) }}</ion-label></ion-col>
                        <ion-col size="12" size-md="2">
                        <ion-label class="edit-corporate"  @click="editCorporateName(item, index)">Edit</ion-label>
                        </ion-col>
                    </ion-row>
                </ion-col>
            </ion-row>
            <ion-row v-if="norecordsfound">
                <ion-col size="12" class="pagination-info">
                <ion-label class="pagination-info">No records found for the selected filters</ion-label>
                </ion-col>
            </ion-row>
            <ion-row v-else>
                <ion-col size="12" size-md="5">
                <ion-label
                    class="pagination-info"
                >Showing {{((pageRecords * pageNo) <= totalRecords) ? (pageRecords * pageNo) : totalRecords}} of {{totalRecords}} results</ion-label>
                </ion-col>
                <ion-col size="12" size-md="7" class="ion-text-right">
                <div class="pagination">
                    <a class="prev" v-if="this.pageNo > 1" @click="loadPage(pageNo - 1)">Prev</a>
                    <a class="prev disabled" v-else>Prev</a>
                    <a
                    
                    v-for="page in this.pagesList"
                    :key="page"
                    v-bind:class="{'active': pageNo == page}"
                    @click="loadPage(page)"
                    >{{page}}</a>
                    <a
                    
                    class="next"
                    v-if="this.pageNo < this.totalPages"
                    @click="loadPage(pageNo + 1)"
                    >Next</a>
                    <a class="next disabled" v-else>Next</a>
                </div>
                </ion-col>
            </ion-row>
        </ion-grid>
    </div>
</template>

<script>
import { defineComponent } from "vue";
import { refresh, create } from 'ionicons/icons';
import { IonButton, IonCol, IonGrid, IonIcon, IonInput, IonLabel, IonRow, IonSelect, IonSelectOption} from "@ionic/vue";
import moment from "moment";
import { PaginationUtils } from "../../util/pagination-utils";
import { EVCStationService } from "../../service/evcstation/stations.service";
import { migratedTryParseServiceError } from "../../service";
import { ToastUtils } from "../../util/toast-utils";
import { AdminService } from "@/service/admin/admin.service";

export default defineComponent({
    name: 'CorporateNameList',
    components:{
        IonIcon, IonGrid, IonRow, IonCol, IonIcon, IonButton, IonSelect, IonSelectOption, IonLabel, IonInput
    },
    data(){
        return{
            refresh,
            create,
            loaderTab: true,
            corporateList: [],
            corporateName: '',
            statuss: '',
            totalRecords: 0,
            pageRecords: 10,
            pageNo: 1,
            pagesList: [],
            totalPages: 0,
            statuses: [],
            norecordsfound: true
        }
    },
    async mounted() {
        localStorage.removeItem("corporateDetails");
        localStorage.removeItem("editIndex");
        this.statuses = await new AdminService().getCorporateStatus();

        var page = localStorage.getItem('corporatePage');
        if (page) {
        this.pageNo = Number(page);
        }
        var search = localStorage.getItem('corporateSearch');
        if (search) {
            search = JSON.parse(search);
            this.corporateName = search.corporateName;
            this.statuss = search.statuss;
            this.searchCorporate();
        } else {
            this.searchCorporate()
        }

        
    },

    methods: {
         convertUppercase(value) {
            return value.toUpperCase()
        },
        addCorporateNameInFilter(corporateName) {
            document.getElementById('corporateName').value = corporateName;
            this.corporateName = corporateName;
        },
        changeDateFormatWithoutTime(dateValue) {
            if(dateValue != null) {
                return moment(dateValue).format('DD/MMM/YYYY')
            }
        },
        editCorporateName(item, index) {
            localStorage.setItem("corporateDetails", JSON.stringify(item));
            localStorage.setItem("editIndex", index); 
            this.$router.push("addNewCorporate");
        },

        async searchCorporate() {
            let existingFilterData = JSON.parse(localStorage.getItem("corporateSearch"))
            let searchFilterData = {
                    corporateName: this.corporateName,
                    statuss: this.statuss
                }
            if(!this.areFiltersEqual(searchFilterData, existingFilterData)) {
                localStorage.setItem("corporateSearch",JSON.stringify(searchFilterData));
                this.pageNo = 1;
                localStorage.setItem('corporatePage', this.pageNo);
            } else {
                let pageNo = localStorage.getItem('corporatePage');
                if(pageNo) {
                    this.pageNo = pageNo;
                } else {
                    this.pageNo = 1;
                }
            }
            try {
                let result = await new AdminService().corporateNameList(
                    this.pageNo,
                    this.pageRecords,
                    {
                    corporateName: this.corporateName,
                    statuss: this.statuss
                    }
                );
                this.corporateList = result.data.corporateList;
                if(this.corporateList.length > 0) {
                    this.totalRecords = result.meta.totalrecords;
             
                    (this.pagesList = new PaginationUtils().getPagesList(
                        this.totalRecords,
                        this.pageRecords,
                        this.pageNo
                    )),
                        (this.totalPages = new PaginationUtils().getTotalPages(
                        this.totalRecords,
                        this.pageRecords
                        ));
                    this.norecordsfound = false;
                } else {
                    this.norecordsfound = true;
                }
                
                if(result.data.success) {
                    new ToastUtils().presentToast(result.data.message);
                }
            } catch(error) {
                this.loaderTab = false;
                let serviceError = migratedTryParseServiceError(error);
                new ToastUtils().presentToast(serviceError.description);
            }
            
            (this.totalPages = new PaginationUtils().getTotalPages(
                this.totalRecords,
                this.pageRecords
            ));
        },

        areFiltersEqual(a, b) {
            return JSON.stringify(a) === JSON.stringify(b);
        },
        
        async loadPage(page) {
            try {
                this.pageNo = page;
                localStorage.setItem('corporatePage', page);
                await this.searchCorporate(); 
            } catch (error) {
                let serviceError = migratedTryParseServiceError(error);
                new ToastUtils().presentToast(serviceError.description);
            }
        },
        
        clearFields() {
            this.pageRecords = 10,
            this.pageNo = 1,
            this.corporateName = "";
            this.statuss = "";
            this.searchCorporate()
        },
    }
})
</script>

<style scoped>
.container-div{
    /* width: 30%; */
    margin-top: 20px;
    border: 2px solid rgb(240, 236, 236);
    border-radius: 20px;
    box-shadow: 2px 2px rgb(70, 68, 68);
    
}
.usage-txt{
    font-size: 22px;
    text-align: center;
}
.report-list{
    margin: 80px 0 0 0;
}
.edit-corporate {
    width: 75px;
  padding-left: 12px;
  padding-right: 12px;
  background: #b22123 0% 0% no-repeat padding-box;
  border-radius: 3px;
  text-align: left;
  font-family: "Roboto";
  font-size: 11px;
  letter-spacing: 0;
  color: #ffffff;
  opacity: 1;
  cursor: pointer;
}
</style>